// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1BZj4","resendInfoText":"OnGoingPaymentBox_resendInfoText__3mvca"};